export default __webpack_public_path__ + "static/media/texture.7a064f06.png";